import BaseService from "./Base.Service";

class UserPermissionsService extends BaseService {
  constructor() {
    super("user-permissions");
  }

  async me() {
    const { data } = await this.conn.axios.get(`/user-permissions/me`);
    return data;
  }

  async catalog() {
    const { data } = await this.conn.axios.get(`/user-permissions/catalog`);
    return data;
  }

  async listUsers() {
    const { data } = await this.conn.axios.get(`/user-permissions/users`);
    return data;
  }

  async getUser(userId) {
    const { data } = await this.conn.axios.get(`/user-permissions/users/${userId}`);
    return data;
  }

  /** Grava o conjunto final de itens da pessoa: [{ key, resource_ids }]. */
  async setUser(userId, items) {
    const { data } = await this.conn.axios.put(`/user-permissions/users/${userId}`, { items });
    return data;
  }
}

export default UserPermissionsService;
